import React, { useCallback } from 'react';
import { Styled } from './styled';
import { Tag } from './tag';


export interface TagsInputProps {
  name?: string;
  placeHolder?: string;
  tags: string[];
  invalidTags?: string[];
  separators?: string[];
  disableBackspaceRemove?: boolean;
  disabled?: boolean;
  isEditOnRemove?: boolean;
  onChange: (tags: string[]) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const defaultSeparators = ['Enter'];

export const TagsInput: React.FC<TagsInputProps> = ({
  name,
  placeHolder,
  tags,
  onChange,
  separators,
  disableBackspaceRemove,
  disabled,
  isEditOnRemove,
  onKeyUp,
  invalidTags,
}: TagsInputProps) => {
  const handleOnKeyUp = useCallback(e => {
    e.stopPropagation();

    const text = e.target.value;

    if (
      !text &&
      !disableBackspaceRemove &&
      tags.length &&
      e.key === 'Backspace'
    ) {
      e.target.value = isEditOnRemove ? `${tags[tags.length -1]} ` : '';
      onChange(tags.slice(0, -1));
    }

    if (text && (separators || defaultSeparators).includes(e.key)) {
      e.preventDefault();

      if (tags.includes(text)) {
        return;
      }
      onChange(tags.concat(text));
      e.target.value = '';
    }
  }, [tags]);

  const onTagRemove = useCallback(text => {
    const newTags = tags.filter(tag => tag !== text);
    onChange(newTags);
  }, [tags]);


  return (
    <Styled.Container>
      {tags.map(tag => (
        <Tag
          key={tag}
          text={tag}
          remove={onTagRemove}
          disabled={disabled}
          hasProblem={invalidTags && invalidTags.includes(tag)}
        />
      ))}

      <Styled.Input
        type="text"
        name={name}
        placeholder={placeHolder}
        onKeyDown={handleOnKeyUp}
        disabled={disabled}
        onKeyUp={onKeyUp}
      />
    </Styled.Container>
  );
};

